export default "__VITE_ASSET__CTzWuKU6__"